/**
 * L2-R7: moved from `src/app/shared/functions/first-element.ts`. It was the only member of the
 * 11-module `@shared/functions` barrel the reports remote needed, and importing the barrel dragged
 * the other ten modules into the remote's bundle.
 *
 * Returns the first element of given array
 * @param x
 * @returns
 */
export const firstElement = <T>(x: T[]) => x[0];
